import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import Storage from 'mewe/shared/storage';
import EnvironmentUtils from 'mewe/utils/environment-utils';
import PostUtils from 'mewe/utils/post-utils';

export default class MwPostThumbnail extends Component {
  @service account;

  @tracked displayType;

  constructor() {
    super(...arguments);
    this.displayType = PostUtils.getDisplayType(this.post);
  }

  get post() {
    return this.args.post;
  }

  get isPostUnavailable() {
    return !this.post;
  }

  get isNsfwPreview() {
    const isNsfwAllowed = Storage.get(Storage.keys.allowNsfwContentSetting);
    if (this.post?.userId === this.account.activeUser.id || isNsfwAllowed) {
      return false;
    }
    return this.post?.photo?.isNsfw;
  }

  get showMediaPlayIcon() {
    return !this.isNsfwPreview && (this.post?.isVideo || this.post?.photo?.animated);
  }

  get photosCount() {
    return this.post?.mediasCount > 1 ? `1/${this.post?.mediasCount}` : null;
  }

  get filesCount() {
    if (this.displayType === 'file' && this.post?.files.length) {
      return this.post?.files.length > 1 ? `1/${this.post?.files.length}` : null;
    }
  }

  get photoUrl() {
    const p = this.post;
    if (!p) return;

    if (p.medias?.[0]?.photo?._links?.img?.href) {
      return EnvironmentUtils.getImgHost(true) + p.medias[0].photo._links.img.href;
    } else if (p.link?._links?.thumbnail?.href) {
      return p.link._links.thumbnail.href;
    }
  }

  get displayIcon() {
    if (this.isPostUnavailable || this.post?.sticker) {
      return null;
    }

    switch (this.displayType) {
      case 'poll':
        return 'svg_icon-poll_new';
      case 'audio':
        return 'svg_audio_play';
      case 'file':
        return 'svg_icon-file_new';
      case 'link':
        return 'icn_chain';
      default:
        return null;
    }
  }

  get noThumbnail() {
    return !this.photoUrl && !this.displayIcon && !this.post?.sticker;
  }
}
